import { render, staticRenderFns } from "./ExpenseError.vue?vue&type=template&id=6be3165e&scoped=true&"
import script from "./ExpenseError.vue?vue&type=script&lang=js&"
export * from "./ExpenseError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be3165e",
  null
  
)

export default component.exports